import { Loader } from '@googlemaps/js-api-loader';
import * as Sentry from '@sentry/ember';

export function initialize(/* application */) {
  const loader = new Loader({
    apiKey: 'AIzaSyBIabTB0auqdU8QpuVSFIRwYwkxnTljiHQ&',
    version: 'quarterly',
    libraries: ['places'],
  });

  loader.load().catch((error) => {
    // Most google maps issues are because they are blocked in certain regions
    // This just helps us format the error a little

    console.log(error);
    Sentry.captureException('Google maps failed to load');
  });
}

export default {
  initialize,
};
